export const ADD_RECENT = 'ADD_RECENT';



// WEBPACK FOOTER //
// ./src/modules/state/recent/Constants.js